import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CreateModal, { CreateModalProps } from "./index";

interface AiAssessmentScaleCreateModalProps
  extends Omit<CreateModalProps, "onSubmit"> {
  onSubmit: (input: any) => Promise<void>;
}

const AiAssessmentScaleSpecificFields: React.FC<{
  context: string;
  setContext: (context: string) => void;
}> = ({ context, setContext }) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <label
        className={`inline-block text-sm font-medium text-teal-700 dark:text-teal-300`}
      >
        {t("homeworkIdeas.form.context")}
      </label>
      <textarea
        value={context}
        onChange={(e) => setContext(e.target.value)}
        className={`w-full rounded-xl border-2 border-gray-200 dark:border-gray-700 p-4 text-base focus:ring-2 focus:ring-teal-500 focus:border-transparent dark:bg-gray-700/50 transition-all duration-200 min-h-[120px]`}
        placeholder={t("homeworkIdeas.form.contextPlaceholder")}
      />
    </div>
  );
};

export const AiAssessmentScaleCreateModal: React.FC<
  AiAssessmentScaleCreateModalProps
> = ({ onSubmit, ...props }) => {
  const [context, setContext] = useState(
    (props.initialInput as any).context || "",
  );

  const handleSubmit = async (input: any) => {
    let submissionData = { ...input };

    // Combine context with prompt if context is provided
    if (context.trim()) {
      submissionData.prompt = `${context.trim()}\n\n${input.prompt}`;
    }

    await onSubmit(submissionData);
  };

  return (
    <CreateModal
      {...props}
      themeColor="teal"
      onSubmit={handleSubmit}
      after={
        <AiAssessmentScaleSpecificFields
          context={context}
          setContext={setContext}
        />
      }
    />
  );
};

export default AiAssessmentScaleCreateModal;
